import { render, staticRenderFns } from "./_upload_form.vue?vue&type=template&id=6f48d8f6&"
import script from "./_upload_form.vue?vue&type=script&lang=js&"
export * from "./_upload_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports